<template>
<p>Bent u projectontwikkelaar, architect, aannemer of inwoner van Maassluis en bereidt u plannen voor een nieuwe of te
    verbeteren openbare ruimte? Dan moet u rekening houden met het Handboek Inrichting Openbare Ruimte. Met deze webtool
    kunt u de richtlijnen van Maassluis voor ontwerp, uitvoering en beheer opvragen, die bijdragen aan een duurzame en
    toekomstbestendige openbare ruimte. Vanzelfsprekend dient u aan wettelijke eisen te voldoen, deze zijn niet
    opgenomen in de richtlijnen. U kunt enkel goed gemotiveerd en bij akkoord afwijken van de richtlijnen van
    Maassluis.</p>
<p>U kunt hier direct starten met het opvragen van alle richtlijnen of specifiek de richtlijnen voor uw project. Dit
    laatste doet u door het doorlopen van 3 stappen waarna u de resultaten kunt inzien en bewaren.</p>
</template>
